module.exports = __webpack_public_path__ + "static/media/watingIcon (1).21b7d8fc.svg";